import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';

import { Room, RoomsResponse } from '../types';
type UseBusinessOptions = {
  businessId?: number;
  businessLocationId?: number | string;
  page?: number;
  perPage?: number;
  search?: string;
};
export const getRooms = (
  { page, perPage, search }: UseBusinessOptions = {
    page: 1,
    perPage: 10,
  }
): Promise<RoomsResponse> => {
  return axios.get(`/rooms/all`, {
    params: { page, perPage, search },
  });
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getRooms>;
};

export const useGetRooms = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getRooms,
  });
};

type UseBusinessOptions1 = {
  roomId?: number;
  startDate?: string;
  endDate?: string;
  page?: number;
  bookingId?: any;
};

type Response = {
  busyDays?: any;
  holidays?: any;
};
export const getBookedRooms = (
  { roomId, startDate, endDate, bookingId }: UseBusinessOptions1 = {
    page: 1,
  }
): Promise<Response> => {
  return axios.get(`/rooms/${roomId}/boarding/availability`, {
    params: { startDate, endDate, bookingId: bookingId ? bookingId : null },
  });
};

type UseUpdateBusinessOptions1 = {
  config?: MutationConfig<typeof getBookedRooms>;
};

export const useGetBookedDateForRooms = ({ config }: UseUpdateBusinessOptions1 = {}) => {
  return useMutation({
    ...config,
    mutationFn: getBookedRooms,
  });
};
